interface vatDeclaration {
    title?: string,
    rowspan?: number,
    item: string,
    col: string,
    row: string,
    val1: string,
    val2: string,
    val3: string,
    val4: string,
    oneEdit?: boolean,
    twoEdit?: boolean,
    noTwo?: boolean,
}

let list = [
    {
        title: "一、计税依据",
        rowspan: 15,
        item: "（一） 应征增值税不含税销售额（3%征收率）",
        col: "1",
        row: "1",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "增值税专用发票不含税销售额 ",
        col: "2",
        row: "2",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "其他增值税发票不含税销售额",
        col: "3",
        row: "3",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "（二）应征增值税不含税销售额（5%征收率）",
        col: "4",
        row: "4",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        twoEdit: true
    },
    {
        item: "增值税专用发票不含税销售额",
        col: "5",
        row: "5",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        twoEdit: true
    },
    {
        item: "其他增值税发票不含税销售额",
        col: "6",
        row: "6",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        twoEdit: true
    },
    {
        item: "（三）销售使用过的固定资产不含税销售额",
        col: "7(7≥8)",
        row: "7",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true
    },
    {
        item: "其中：其他增值税发票不含税销售额",
        col: "8",
        row: "8",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true
    },
    {
        item: "（四）免税销售额",
        col: "9=10+11+12",
        row: "9",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
    },
    {
        item: "其中：小微企业免税销售额",
        col: "10",
        row: "10",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "未达起征点销售额",
        col: "11",
        row: "11",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "其他免税销售额",
        col: "12",
        row: "12",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "（五）出口免税销售额",
        col: "13(13≥14)",
        row: "13",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "其中：税控器具开具的普通发票销售额",
        col: "14",
        row: "14",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "核定销售额",
        col: "15",
        row: "15",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        title: "二、税款计算",
        rowspan: 9,
        item: "本期应纳税额",
        col: "16",
        row: "16",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "核定应纳税额",
        col: "17",
        row: "17",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "本期应纳税额减征额",
        col: "18",
        row: "18",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "本期免税额",
        col: "19",
        row: "19",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "其中：小微企业免税额",
        col: "20",
        row: "20",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "未达起征点免税额",
        col: "21",
        row: "21",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true
    },
    {
        item: "应纳税额合计",
        col: "22",
        row: "22",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
    },
    {
        item: "本期预缴税额",
        col: "23",
        row: "23",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true,
        noTwo: true
    },
    {
        item: "本期应补（退）税额",
        col: "24",
        row: "24",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        noTwo: true
    }
];
let vatDeclaration = {
    list: list,
}
export default vatDeclaration